import React from "react";
import PropTypes from "prop-types";
import { Button, Modal, Menu, Card, Row } from "antd";
import ListView from "components/common/ListView";
import MaterialIcon from "components/common/MaterialIcon";
import { connect } from "react-redux";
import TimeTextField from "../TimeTextField";
import store from "store";
import { patchUser, showUser, emptyUser } from "../Module";

import {
  indexUserFinancials,
  emptyUserFinancials,
  destroyUserFinancial,
} from "../Module";

@authorize
@connect(
  (state) => ({
    financialInfos: state.Basic.Personnel.financialInfos,
    user: state.Basic.Personnel.user,
  }),
  {
    index: indexUserFinancials,
    empty: emptyUserFinancials,
    destroy: destroyUserFinancial,
    show: showUser,
    empty: emptyUser,
  }
)
@autobind
/**
 *
 */
export default class Setting extends React.PureComponent {
  static propTypes = {
    banks: PropTypes.arrayOf(PropTypes.object),
    user: PropTypes.object,
    can: PropTypes.func,
    onAdd: PropTypes.func,
    onEdit: PropTypes.func,
    index: PropTypes.func,
    empty: PropTypes.func,
    destroy: PropTypes.func,
    financialInfos: PropTypes.array,
  };

  /**
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      user: null,
      ceiling_overtime: "",
    };
  }

  /**
   *
   */
  componentDidMount() {
    const { index, item, show } = this.props;
    console.log("itemitemitemitemitem", item);
    this.setState({
      ceiling_overtime:this.props.user?.profile?.ceilingOvertime
    })
    // this.setState({
    //   ceiling_overtime:this.props.user?.profile?.ceilingOvertime
    // })
    // index(item.id, (err) => !err && this.setState({ loading: false }));
  }

componentDidUpdate(){
  console.log("this.props?.user?.profile",this.props?.user?.profile);
  // this.setState({
  //   ceiling_overtime:this.props.user?.profile?.ceilingOvertime
  // })
}

  
  /**
   *
   * @param {Object} item
   * @return {XML}
   * @private
   */
  _menu(item) {
    const { can, onEdit } = this.props;

    return (
      <Menu
        onClick={({ key }) => {
          switch (key) {
            case "edit":
              onEdit(item);
              break;
            case "delete":
            default:
              this._onDelete(item);
          }
        }}
      >
        <Menu.Item key="edit" disabled={!can("FinancialInfo@update")}>
          <MaterialIcon name="pencil" />
          {app.translate("main.Edit")}
        </Menu.Item>
        <Menu.Item key="delete" disabled={!can("FinancialInfo@destroy")}>
          <MaterialIcon name="delete" />
          {app.translate("main.Delete")}
        </Menu.Item>
      </Menu>
    );
  }

  /**
   *
   * @param {Object} item
   * @private
   */
  _onDelete(item) {
    const { destroy } = this.props;

    Modal.confirm({
      title: app.translate("routes.home.basic.personnel.Removing financial"),
      content: app.translate(
        "routes.home.basic.personnel.Are you sure removing financial with number",
        { number: item.accountNumber || item.cardNumber }
      ),
      onOk: () => destroy(item.id),
    });
  }
  updateData(newValue) {
    const { user } = this.props;
    console.log("newValue", newValue);
    console.log("user", user);
    this.setState({
      ceiling_overtime: newValue,
    });
  }
  _submit() {
    const { user } = this.props;
    const { index, item, show } = this.props;

    console.log("user.profile", user.profile?.ceilingOvertime);
    store.dispatch(
      patchUser(item.id, {
        profile: { ceiling_overtime: this.state.ceiling_overtime },
      })
    );
  }
  /**
   *
   * @return {XML}
   */
  render() {
    const { loading, user,ceiling_overtime } = this.state;
    const { onAdd, financialInfos, onEdit, banks, item } = this.props;
    console.log(
      "user?.profile?.ceilingOvertime",
      item?.profile?.ceilingOvertime
    );
    console.log("this.state.use.profile",this.state?.user?.profile);
    console.log("this.state.use.profile2",this.props?.user?.profile);
    console.log("ceiling_overtimeceiling_overtime",ceiling_overtime);
    return (
      <Row style={{ height: "100%" }}>
        {/* <Row>
          {item?.profile?.firstName} {item?.profile?.lastName}
        </Row> */}

        <div style={{ width: "max-content", padding: "0 0 0 10px" }}>
          {app.translate("سقف اضافه‌کار ماهیانه ")}
        </div>
        <div key={this.state?.user?.profile}>
        <TimeTextField
          //  value={_data.monthRemainings[i] || '00:00'}
          defaultValue={
            item?.profile?.ceilingOvertime
              ? item?.profile?.ceilingOvertime
              : "00:00"
          }
          itemcheck={item}
          onChange={(newValue, index) => {
            console.log("newValue", newValue);

            // let changedData = { ..._data };
            // if (
            //   changedData.monthRemainings &&
            //   changedData.monthRemainings.length === 0
            // ) {
            //   changedData.monthRemainings = {};
            // }
            // changedData.monthRemainings[index] = newValue;

            this.updateData(newValue);
          }}

          // disabled={locked}
        /></div>
        <Button
          type="primary"
          onClick={this._submit}
          style={{ marginTop: "8px" }}
        >
          {app.translate("ثبت")}
        </Button>
      </Row>
    );
  }
}
